module.exports = __webpack_public_path__ + "img/2.a2f91217.png";